export default __webpack_public_path__ + "static/media/logo-bitchingham-1.268b18b9.png";